/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Data_StaleInputs */

const vi_station_data_stale = /** @type {(inputs: Station_Data_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa cập nhật được danh sách đơn. Kiểm tra kết nối rồi thử lại.`)
};

/**

* @param {Station_Data_StaleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_data_stale = /** @type {((inputs?: Station_Data_StaleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Data_StaleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_data_stale(inputs)
});